class SiteHeader extends HTMLElement {
  connectedCallback() {
    const drawer = this.querySelector('.hd__drawer');
    const opener = this.querySelector('[data-menu-open]');
    const toggle = (open) => {
      drawer.hidden = !open;
      opener.setAttribute('aria-expanded', open);
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) drawer.querySelector('button').focus();
      else opener.focus();
    };
    opener.addEventListener('click', () => toggle(true));
    this.querySelectorAll('[data-menu-close]').forEach((b) => b.addEventListener('click', () => toggle(false)));
    document.addEventListener('keydown', (e) => e.key === 'Escape' && !drawer.hidden && toggle(false));

    /* Mobile drawer accordion */
    this.querySelectorAll('[data-acc] > button').forEach((btn) => btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open);
      document.getElementById(btn.getAttribute('aria-controls')).hidden = !open;
    }));

    /* Desktop mega menu: opens on hover/focus, closes on leave/Escape */
    const items = [...this.querySelectorAll('[data-mega]')];
    const setOpen = (item, open) => {
      item.querySelector('.hd__mega').hidden = !open;
      item.querySelector('.hd__link').setAttribute('aria-expanded', open);
    };
    items.forEach((item) => {
      let timer;
      const open = () => { clearTimeout(timer); items.forEach((o) => o !== item && setOpen(o, false)); setOpen(item, true); };
      const close = () => { clearTimeout(timer); timer = setTimeout(() => setOpen(item, false), 180); };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', (e) => !item.contains(e.relatedTarget) && close());
    });
    document.addEventListener('keydown', (e) => e.key === 'Escape' && items.forEach((i) => setOpen(i, false)));

    /* Predictive search */
    const form = this.querySelector('[data-search]');
    const input = form.querySelector('input[name=q]');
    const box = form.querySelector('[data-suggest]');
    const run = theme.debounce(async () => {
      const q = input.value.trim();
      if (q.length < 2) return (box.hidden = true);
      const url = `${this.dataset.suggestUrl}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`;
      const res = await fetch(url);
      if (!res.ok) return;
      const items = (await res.json()).resources.results.products || [];
      box.innerHTML = '';
      items.forEach((p) => {
        const a = document.createElement('a');
        a.href = p.url;
        if (p.image) { const i = document.createElement('img'); i.src = p.image; i.alt = ''; i.width = 44; i.height = 44; a.append(i); }
        const t = document.createElement('span'); t.textContent = p.title; a.append(t);
        const pr = document.createElement('span'); pr.className = 'num'; pr.textContent = theme.money(Math.round(parseFloat(p.price) * 100)); a.append(pr);
        box.append(a);
      });
      box.hidden = !items.length;
    }, 200);
    input.addEventListener('input', run);
    document.addEventListener('click', (e) => !form.contains(e.target) && (box.hidden = true));
  }
}
customElements.define('site-header', SiteHeader);
